import api from '@services/api'

export default {
  get(axios, params, query, config) {
    return api.get(axios, '/organization', params, query, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/organization', params, payload, config)
  },

  userinfo(axios, params, config) {
    return api.get(axios, '/organization/userinfo', params, config)
  },

  panel(axios, params, config) {
    return api.get(axios, '/organization/panel', params, config)
  },

  uniqueIdentity(axios, params, query, config) {
    return api.get(axios, '/organization/unique_identity', params, query, config)
  },

  attachment(axios, params, payload, config) {
    return api.update(axios, '/organization/attachment/:attachment', params, payload, config)
  },
}
